<template>

  <v-container fluid>

    <!-- 이미지 크롭 팝업 -->
    <v-row>
      <v-dialog persistent scrollable overlay-color="#00000040" v-model="crop_dialog_land" @keydown.esc="cancel_crop"  max-width="500px">
        <v-card class="dialog_round pa-10">

          <v-row dense align="center">
            <v-col cols="11" md="11" sm="11" xs="11">
              <span class="dialog_title">{{$t("common_crop")}}</span>
            </v-col>
            <v-col cols="1" md="1" sm="1" xs="1">
              <v-btn class="dialog_close_btn mr-1" outlined rounded fab x-small @click="cancel_crop"><v-icon>mdi-close</v-icon></v-btn>
            </v-col>
          </v-row>

          <v-row dense justify="center">
            <v-col cols="12" md="12" sm="12" xs="12">
              <div style="background:#4e6ef7;height:2px;" />
            </v-col>
          </v-row>

          <v-card-text>
            <vue-cropper
                ref="cropper_land"
                :aspectRatio="16/9"
                :src="imgSrc"
                preview=".preview"
                />
          </v-card-text>
          <v-card-actions>
            <v-row justify="center">
            <v-btn class="dialog_cancel_btn mr-5" rounded large @click="cancel_crop">{{$t("common_cancel")}}</v-btn>
            <v-btn class="dialog_btn" rounded large @click="cropimg">{{$t("common_ok")}}</v-btn>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    
    <v-row>
      <v-dialog persistent scrollable overlay-color="#00000040" v-model="crop_dialog_port" @keydown.esc="cancel_crop" max-width="500px">
        <v-card class="dialog_round pa-10">
          <v-row dense align="center">
            <v-col cols="11" md="11" sm="11" xs="11">
              <span class="dialog_title">{{$t("common_crop")}}</span>
            </v-col>
            <v-col cols="1" md="1" sm="1" xs="1">
              <v-btn class="dialog_close_btn mr-1" outlined rounded fab x-small @click="cancel_crop"><v-icon>mdi-close</v-icon></v-btn>
            </v-col>
          </v-row>

          <v-row dense justify="center">
            <v-col cols="12" md="12" sm="12" xs="12">
              <div style="background:#4e6ef7;height:2px;" />
            </v-col>
          </v-row>

          <v-card-text>
            <vue-cropper
                ref="cropper_port"
                :aspectRatio="9/16"
                :src="imgSrc"
                preview=".preview"
                />
          </v-card-text>
          <v-card-actions>
            <v-row justify="center">
            <v-btn class="dialog_cancel_btn mr-5" rounded large @click="cancel_crop">{{$t("common_cancel")}}</v-btn>
            <v-btn class="dialog_btn" rounded large @click="cropimg">{{$t("common_ok")}}</v-btn>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <v-row>
      <v-dialog persistent scrollable overlay-color="#00000040" v-model="crop_dialog_print" @keydown.esc="cancel_crop" max-width="500px">
        <v-card class="dialog_round pa-10">
          <v-row dense align="center">
            <v-col cols="11" md="11" sm="11" xs="11">
              <span class="dialog_title">{{$t("common_crop")}}</span>
            </v-col>
            <v-col cols="1" md="1" sm="1" xs="1">
              <v-btn class="dialog_close_btn mr-1" outlined rounded fab x-small @click="cancel_crop"><v-icon>mdi-close</v-icon></v-btn>
            </v-col>
          </v-row>

          <v-row dense justify="center">
            <v-col cols="12" md="12" sm="12" xs="12">
              <div style="background:#4e6ef7;height:2px;" />
            </v-col>
          </v-row>

          <v-card-text>
            <vue-cropper
                ref="cropper_print"
                :aspectRatio="1080/1150"
                :src="imgSrc"
                preview=".preview"
                />
          </v-card-text>
          <v-card-actions>
            <v-row justify="center">
            <v-btn class="dialog_cancel_btn mr-5" rounded large @click="cancel_crop">{{$t("common_cancel")}}</v-btn>
            <v-btn class="dialog_btn" rounded large @click="cropimg">{{$t("common_ok")}}</v-btn>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>    

    <!-- 배경그룹 추가/수정 팝업 -->
    <v-row>
      <v-dialog persistent scrollable overlay-color="#00000040" v-model="dialog" @keydown.esc="close" max-width="500px">
        <v-card class="dialog_round pa-10">

          <v-row dense align="center">
            <v-col cols="11" md="11" sm="11" xs="11">
              <span class="dialog_title">{{ dialogTitle }}</span>
            </v-col>
            <v-col cols="1" md="1" sm="1" xs="1">
              <v-btn class="dialog_close_btn mr-1" outlined rounded fab x-small @click="close"><v-icon>mdi-close</v-icon></v-btn>
            </v-col>
          </v-row>

          <v-row dense justify="center">
            <v-col cols="12" md="12" sm="12" xs="12">
              <div style="background:#4e6ef7;height:2px;" />
            </v-col>
          </v-row>

          <v-card-text>
            <v-container>
                <v-row>
                  <v-text-field v-model="editedItem.NAME" :label="$t('deviceadminbg_col1')"></v-text-field>
                </v-row>
                <v-row>
                  <v-text-field v-model="editedItem.DESC" :label="$t('common_userinfo_label16')"></v-text-field>
                </v-row>
                <v-row>
                  <v-select v-model="editedItem.BGTYPE" :items="BGLIST" :label="$t('deviceadminbg_label1')" :item-text="this.$i18n.locale == 'ko' ? 'name' : 'name2'" item-value="value"/>
                </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-row justify="center">
            <v-btn class="dialog_cancel_btn mr-5" rounded large @click="close">{{$t("common_cancel")}}</v-btn>
            <v-btn class="dialog_btn" rounded large @click="save">{{$t("common_ok")}}</v-btn>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>  
    </v-row>

    <!-- 배경컨텐츠 추가/수정 팝업 -->
    <v-row>
      <v-dialog persistent scrollable overlay-color="#00000040" v-model="dialog2" @keydown.esc="dialog2 = false" max-width="500px">
        <v-card class="dialog_round pa-10">

          <v-row dense align="center">
            <v-col cols="11" md="11" sm="11" xs="11">
              <span class="dialog_title">{{$t('deviceadminbg_label2')}}</span>
            </v-col>
            <v-col cols="1" md="1" sm="1" xs="1">
              <v-btn class="dialog_close_btn mr-1" outlined rounded fab x-small @click="dialog2 = false"><v-icon>mdi-close</v-icon></v-btn>
            </v-col>
          </v-row>

          <v-row dense justify="center">
            <v-col cols="12" md="12" sm="12" xs="12">
              <div style="background:#4e6ef7;height:2px;" />
            </v-col>
          </v-row>

          <v-card-text>
            <v-container>
                <v-row dense>
                  <v-col md="12" sm="12" xs="12">
                    <v-text-field v-model="editedItem2.TITLE" :label="$t('deviceadminbg_col5')" ></v-text-field>
                  </v-col>
                </v-row>
                <v-row dense>
                  <v-col md="12" sm="12" xs="12">
                    <v-select v-model="editedItem2.STATE" :items="STATELIST" :label="$t('common_userinfo_label13')" :item-text="this.$i18n.locale == 'ko' ? 'name' : 'name2'" item-value="value"/>
                  </v-col>
                </v-row>
                <v-row dense>
                  <v-col md="12" sm="12" xs="12">
                    <v-select v-model="editedItem2.TYPE" :items="TYPELIST" :label="$t('deviceadminbg_label3')" :item-text="this.$i18n.locale == 'ko' ? 'name' : 'name2'" item-value="value"/>
                  </v-col>
                </v-row>

                <template v-if="editedItem2.TYPE == 0">
                  <v-row>
                    <v-img
                      :src="editedItem2.FILEPATH"
                      width="200" height="112" contain style="background-color:gray"
                      >
                    </v-img>
                  </v-row>
                  <v-row dense>
                    <v-col md="12" sm="12" xs="12" class="ma-0 pa-0">
                      <v-checkbox v-model="iscrop" dense hide-details :label="$t('deviceadminbg_label7')" />
                    </v-col>
                  </v-row>
                  <v-row v-if="iscrop" dense>
                    <v-col md="12" sm="12" xs="12">
                      <v-file-input accept="image/*" :label="$t('deviceadminbg_label4')" v-model="uploadFile" @change="changefile"></v-file-input>
                    </v-col>
                  </v-row>
                  <v-row v-if="!iscrop" dense>
                    <v-col md="12" sm="12" xs="12">
                      <v-file-input accept="image/*" :label="$t('deviceadminbg_label4')" v-model="uploadFile" @change="changefile2"></v-file-input>
                    </v-col>
                  </v-row>


                </template>

                <template v-if="editedItem2.TYPE == 1">
                  <template v-if="PARENT_ITEM.BGTYPE == 0">
                    <v-row>
                      <v-spacer/>
                        <video style="width:400px;height:225px;" ref="video" :src="editedItem2.FILEPATH" autoplay controls />
                      <v-spacer/>
                    </v-row>
                  </template>
                  <template v-if="PARENT_ITEM.BGTYPE == 1">
                    <v-row>
                      <v-spacer/>
                        <video style="width:225px;height:400px;" ref="video" :src="editedItem2.FILEPATH" autoplay controls />
                      <v-spacer/>
                    </v-row>
                  </template>
                  <template v-if="PARENT_ITEM.BGTYPE == 2">
                    <v-row>
                      <v-spacer/>
                        <video style="width:225px;height:400px;" ref="video" :src="editedItem2.FILEPATH" autoplay controls />
                      <v-spacer/>
                    </v-row>
                  </template>
                  <v-row>
                    <v-col md="12" sm="12" xs="12">
                      <v-file-input accept="video/mp4" :label="$t('deviceadminbg_label5')" v-model="uploadFile" @change="changefile2"></v-file-input>
                    </v-col>
                  </v-row>
                </template>

                <v-row dense>
                  <v-col md="12" sm="12" xs="12">
                    <v-text-field v-model="editedItem2.SORT" :label="$t('common_userinfo_label15')" ></v-text-field>
                  </v-col>
                </v-row>

            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-row justify="center">
            <v-btn class="dialog_cancel_btn mr-5" rounded large @click="dialog2 = false">{{$t("common_cancel")}}</v-btn>
            <v-btn class="dialog_btn" rounded large @click="checks3path">{{$t("common_save")}}</v-btn>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>  
    </v-row>

    <v-row align="center" dense no-gutters>
      <v-col cols="12">
        <label class="menunamestyle">{{this.$session.get("MENUNAME")}}</label>
      </v-col>
    </v-row>

    <v-row align="start" dense>

      <v-col md="5" sm="12" xs="12">
        <v-row dense no-gutters align="center" justify="start">
          <template v-if="grade >= 50">
            <v-col md="6" sm="12" xs="12">
              <comdialog :comname="SEARCH_COM_NAME" @cancelcallback="comsearchclear" @callback="comsearchcb"></comdialog>
            </v-col>
          </template>
          <v-col md="2" align="center">
            <v-btn class="search_btn"  elevation="0" outlined large @click="insert_group">{{$t("common_insert")}}</v-btn>
          </v-col>
          <v-col md="2" align="center">
            <v-btn class="search_btn"  elevation="0" outlined large @click="search_run">{{$t('common_search_list')}}</v-btn>
          </v-col>
        </v-row>
        
        <v-row dense no-gutters align="center" justify="start">
          <v-col cols="6" md="4" class="pa-0" align="center">
            <v-text-field 
              dense single-line clearable
              @keyup.enter="search_run" 
              v-model="search_keyword" 
              :placeholder="$t('common_search_holder')"
              outlined height="43"
              color="#808080"
              hide-details
              />
          </v-col>
          <v-col cols="4" md="2" class="pa-0" align="center">
            <v-btn style="width:94%" class="search_btn_freesize" elevation="0" outlined large @click="search_run">{{$t("common_search")}}</v-btn>
          </v-col>
        </v-row>
      </v-col>
      
      <v-col cols="7" md="6" sm="12" xs="12">
        <v-row>
          <v-col md="4">
            <label class="ml-5 dialog_title">{{ PARENT_ITEM.IDX != null ? PARENT_ITEM.NAME : '' }}</label>
          </v-col>
          <v-spacer/>
          <v-col md="2">
            <v-btn v-if="PARENT_ITEM.IDX != null" class="search_btn_freesize" elevation="0" outlined large @click="insert_img">{{$t('deviceadminbg_label6')}}</v-btn>
          </v-col>
        </v-row>
      </v-col>

  </v-row>      
    
  <v-row align="start">
    
    <v-col cols="12" md="5" sm="12" xs="12">
      
      <!-- 테이블 -->
      <v-data-table
        :headers="headers"
        :items="itemList"
        :no-data-text="$t('common_nodata')"
        hide-default-footer
        class="datatablestyle ml-5 mr-5"
        :items-per-page="pagerow"
        item-key="IDX"
        :loading="loading"
        >
        <template v-slot:header.NAME>
          <label class="cheader_normal" >{{$t("deviceadminbg_col1")}}</label>
        </template>
        <template v-slot:header.DESC>
          <label class="cheader_normal" >{{$t("deviceadminbg_col2")}}</label>
        </template>
        <template v-slot:header.BG_NAME>
          <label class="cheader_normal" >{{$t("deviceadminbg_col9")}}</label>
        </template>
        <template v-slot:header.actions>
          <label class="cheader_normal" >{{$t("deviceadminbg_col8")}}</label>
        </template>

        <template v-slot:item.NAME="{ item }">
            <a  @click="detail_item(item)">{{item.NAME}}</a>
        </template>  
        <template v-slot:item.actions="{ item }">  
            <v-icon class="mr-2" small @click="edit_item(item)">mdi-pencil</v-icon>
            <v-icon small @click="delete_item(item)">mdi-delete</v-icon>
        </template>     
      </v-data-table>
      <v-row>
        <v-col class="d-flex justify-center">
        <v-btn v-if="bottompage > 10" icon  small @click="prev()"><v-icon dark>mdi-chevron-left</v-icon></v-btn>
        <span v-for="n in subpage" :key="n.id">
            <span v-if="page == bottompage-1+n">
                <v-btn color="red" icon small @click="loadpage(bottompage-1+n)">{{bottompage-1+n}}</v-btn>
            </span>
            <span v-else>
                <v-btn icon small @click="loadpage(bottompage-1+n)">{{bottompage-1+n}}</v-btn>
            </span>
        </span>
        <v-btn v-if="subpage == 10" icon small @click="next()" ><v-icon dark>mdi-chevron-right</v-icon></v-btn>
        </v-col>
      </v-row>
    </v-col>
    
    <v-col v-if="PARENT_ITEM.IDX != null" cols="12" md="7" sm="12" xs="12">
      <!-- 테이블 -->
      <v-data-table
        :headers="headers2"
        :items="itemList2"
        :no-data-text="$t('common_nodata')"
        hide-default-footer
        class="datatablestyle ml-5 mr-5"
        item-key="IDX"
        :loading="loading2"
        >
        <template v-slot:header.SORT>
          <label class="cheader_normal" >{{$t("deviceadminbg_col3")}}</label>
        </template>
        <template v-slot:header.FILEPATH>
          <label class="cheader_normal" >{{$t("deviceadminbg_col4")}}</label>
        </template>
        <template v-slot:header.TITLE>
          <label class="cheader_normal" >{{$t("deviceadminbg_col5")}}</label>
        </template>
        <template v-slot:header.TYPE_NAME>
          <label class="cheader_normal" >{{$t("deviceadminbg_col6")}}</label>
        </template>
        <template v-slot:header.STATE_NAME>
          <label class="cheader_normal" >{{$t("deviceadminbg_col7")}}</label>
        </template>
        <template v-slot:header.actions>
          <label class="cheader_normal" >{{$t("deviceadminbg_col8")}}</label>
        </template>

       
        <!-- 특정 컬럼 커스텀 처리 -->
        <template v-slot:item.FILEPATH="{ item }">
          <template v-if="PARENT_ITEM.BGTYPE == 0"> 
            <template v-if="item.TYPE == 0">  
              <v-col class="d-flex justify-center align-center">
                <v-img  :src="item.FILEPATH" width="142" height="80" contain/>
              </v-col>
            </template>
            <template v-if="item.TYPE == 1">
              <video style="width:142px;height:80px;" ref="video" :src="item.FILEPATH" controls />
            </template>
          </template>
          <template v-if="PARENT_ITEM.BGTYPE == 1">
            <template v-if="item.TYPE == 0">
              <v-col class="d-flex justify-center align-center">
                <v-img  :src="item.FILEPATH" width="80" height="142" contain/>
              </v-col>
            </template>
            <template v-if="item.TYPE == 1">
              <video style="width:80px;height:142px;" ref="video" :src="item.FILEPATH" controls />
            </template>
          </template>
          <template v-if="PARENT_ITEM.BGTYPE == 2">
            <template v-if="item.TYPE == 0">
              <v-col class="d-flex justify-center align-center">
                <v-img  :src="item.FILEPATH" width="80" height="133" contain/>
              </v-col>
            </template>
            <template v-if="item.TYPE == 1">
              <v-col class="d-flex justify-center align-center">
                <video style="width:80px;height:133px;" ref="video" :src="item.FILEPATH" controls />
              </v-col>
            </template>
          </template>
        </template>
        
        <!-- 액션처리 - 아이템 슬롯을 재정의 할 수 있지만 기본값이 반응형에 더 최적화 되어있다. -->
        <template v-slot:item.actions="{ item }">  
            <v-icon class="mr-2" small @click="edit_img(item)">mdi-pencil</v-icon>
            <v-icon small @click="delete_img(item)">mdi-delete</v-icon>
        </template>     
        
      </v-data-table>

    </v-col>

  </v-row>

  
  

  </v-container>
</template>

<script>
//import draggable from 'vuedraggable'  //드래그앤 드랍 라이브러리
import VueCropper from 'vue-cropperjs'; //이미지 크롭
import 'cropperjs/dist/cropper.css';

export default {
    components:{
      //draggable,
      VueCropper
    },

    data: () => ({
      
      iscrop:true,

      s3: null,   //aws
      upload_path: null,

      dialog: false,
      dialog2: false,
      crop_dialog_land: false,
      crop_dialog_port: false,
      crop_dialog_print: false,

      selectFile:null,
      imgSrc:'',
      ratio: 16/9,

      //파일 업로드
      uploadFile : null,

      //필수 페이징 파라메터
      totalcnt : 0,       //전체 아이템 개수
      page : 0,
      maxpage : 0,        //전체 페이지 개수
      startpage : 1,      //시작 인덱스
      bottompage : 1,     //하단 페이징 번호의 시작점을 계산하기 위한 변수
      subpage : 1,       //하단 페이징 번호의 종료점을 계산하기 위한 변수
      loading : false,    //로딩 표시

      //CRUD 관련
      dialogTitle: '추가하기',   //다이얼로그 제목
      editedIndex: -1,          //-1이면 신규, -1보다 크면 업데이트
      
      defaultItem: {
          NAME:'',
          DESC:'',
          BGTYPE:0, 
      },
      editedItem: {
      },

      //테이블 정의
      headers: [
        {text: '그룹명',  value: 'NAME', sortable: true, align:'center' },
        {text: '설명', value: 'DESC', sortable: false, align:'center' },
        {text: '배경', value: 'BG_NAME', sortable: false, align:'center' },
        {text: '수정/삭제', value: 'actions', sortable: false, align:'center'}
      ],
      itemList: [],
      
      search_keyword : '',

      //한 페이지 ROW 개수 설정
      pagerow : 20,       //한 페이지에 보여줄 row수
      pagerow_combo : [
          {NAME:'20', VALUE:20}
        , {NAME:'50', VALUE:50}
        , {NAME:'100', VALUE:100}
        , {NAME:'200', VALUE:200}
      ],    
         
      //추가 변수들
      STATELIST: [
          {name:'비활성', name2:"Disable", value:0}
        , {name:'활성', name2:"Enable",  value:1}
      ],

      TYPELIST: [
          {name:'이미지', name2:"Image",  value:0}
        , {name:'동영상', name2:"Video",  value:1}
      ],

      BGLIST: [
          {name:'가로', name2:"Horizontal",  value:0}
        , {name:'세로', name2:"Vertical",  value:1}
        , {name:'프린트', name2:"Print",  value:2}
      ],

      //2번째 테이블
      loading2 : false,   //로딩 표시

      //CRUD 관련
      dialogTitle2: '추가하기',   //다이얼로그 제목
      editedIndex2: -1,          //-1이면 신규, -1보다 크면 업데이트
      defaultItem2: {
          IDX:'',
          ADMIN_IDX:'',
          BGGROUP_IDX:'',
          TITLE:'',
          FILEPATH:'',
          TYPE:0,
          STATE:1,
          SORT:1,
          UP_DATE:'',
      },
      editedItem2: {
      },

      headers2: [
        {text: '순서',  value: 'SORT', sortable: false, align:'center' },
        {text: '컨텐츠',  value: 'FILEPATH', sortable: false, align:'center' },
        {text: '제목',    value: 'TITLE', sortable: true, align:'center'},
        {text: '타입',    value: 'TYPE_NAME', sortable: true, align:'center' },
        {text: '상태',  value: 'STATE_NAME', sortable: true, align:'center' },
        {text: '수정/삭제',    value: 'actions', sortable: true, align:'center' },
      ],
      itemList2: [],

      SEARCH_COM_IDX: null,
      SEARCH_COM_NAME: '',
      SEARCH_EVENT_IDX: null,
      SEARCH_EVENT_NAME: '',
      grade : 0,

      PARENT_ITEM: {},

    }),

    mounted(){

      if(this.$session.get("GRADE") < 10){
        this.$alert(this.$t("common_nograde"));
        this.$router.push("Login");
        return;
      }

      this.SEARCH_COM_IDX    = this.$session.get("COM_IDX");
      this.SEARCH_COM_NAME   = this.$session.get("COM_NAME");
      this.SEARCH_EVENT_IDX  = this.$session.get("EVENT_IDX");
      this.SEARCH_EVENT_NAME = this.$session.get("EVENT_NAME");
      this.grade = this.$session.get("GRADE");

      if(this.$session.exists("ADMIN_IDX")){
        this.initpage();
      }else{
        //키값 없으면 로그인으로
        this.$router.push("Login");
      }
    },

    methods: {
      
      // eslint-disable-next-line no-unused-vars
      checkMove(evt){
        //console.log(evt.draggedContext.element.name);
      },

      dragchange(){
        /*        
        this.itemList2.forEach(element => {

        });
        */
      },

      prev(){
          this.bottompage = this.bottompage - 10 >= 1 ? this.bottompage - 10 : 1;
          this.subpage = this.maxpage - this.bottompage >= 10 ? 10 : this.maxpage - this.bottompage+1;
          var temp_page = this.bottompage + this.subpage - 1; //이전을 누르면 가장 끝 번호 선택
          this.loadpage(temp_page);
      },
      next(){
          this.bottompage = this.bottompage + 10 <= this.maxpage ? this.bottompage + 10 : this.maxpage;
          this.subpage = this.maxpage - this.bottompage >= 10 ? 10 : this.maxpage - this.bottompage+1;
          var temp_page = this.bottompage;
          this.loadpage(temp_page);
      },

      makepaging(){
        var div1 = this.totalcnt / this.pagerow; 
        var div2 = this.totalcnt % this.pagerow;
        if(div2 == 0){  
            this.maxpage = parseInt(div1);    
        }else{
            this.maxpage = parseInt(div1+1);
        }
        if(this.bottompage == 1){
          this.subpage = this.maxpage - this.bottompage >= 10 ? 10 : this.maxpage - this.bottompage+1;
        }
      },

      loadpage(p){

          this.PARENT_ITEM = {};
          this.itemList.splice(0, this.itemList.length);   //데이터 초기화
          
          if(this.SEARCH_COM_IDX == null){
            this.$alert(this.$t('common_select_tcom'));
            return;
          }

          this.loading = true;
          this.page = p;

          this.$http.post(this.$host+'/api/BgGroupList',{
                search_type:''
              , search_keyword: this.search_keyword == null || this.search_keyword == undefined ?  '' : escape(this.search_keyword)
              , sort_type:''
              , page: this.page
              , pagerow: this.pagerow
              , COM_IDX: this.SEARCH_COM_IDX
              , ADMIN_IDX: this.$session.get("ADMIN_IDX")
              , LAN_CODE:this.$i18n.locale
          },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
          .then((result)=>{
            
            if(result.data.resultCode == 0){

              //토큰 저장
              if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
              }
              if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
              }

                this.totalcnt = result.data.totalcnt;
                this.makepaging();
                const list = result.data.resultData;
                
                list.forEach(element => {
                    this.itemList.push(element); 
                });

                this.loading = false;

            }else if(result.data.resultCode == 2){
              //로그인 필요
              this.loading = false;
              this.$alert(this.$t("common_tokener"));
              this.$session.clear("ADMIN_IDX");
              this.$session.clear("COM_IDX");
              this.$session.clear("ACNT_IDX");
              this.$session.clear("GRADE");
              this.$session.clear("COM_NAME");
              this.$session.clear("ACCESSTOKEN");
              this.$session.clear("REFLASHTOKEN");
              this.$router.push('Login');   //로그인 페이지로 이동

            }else{
              this.loading = false;
            }
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error)=>{
            
            this.loading = false;
            if(error.message == 'Request failed with status code 429')
            {
              this.$alert(this.$t("common_reqer"));
            }else{
              this.$alert(error.message);
            }
          });

      },

      initpage(){

        //첫페이지 로드
        this.loadpage(1);

      },      

      //검색
      search_run(){
        this.loadpage(1);
      },

      //배경그룹 추가
      insert_group(){
        if(this.SEARCH_COM_IDX == null){
          this.$alert(this.$t('common_select_tcom'));
          return;
        }
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
        this.dialog = true;
      },

      //아이템 수정
      edit_item(item){
        this.dialogTitle = this.$t('common_edit_title');
        this.editedIndex = this.itemList.indexOf(item)
        //this.editedItem = item;
        this.editedItem = Object.assign({}, item);
        this.dialog = true;
      },

      //배경그룹 삭제
      delete_item(item){

        this.$confirm(this.$t("common_delete_msg"))
        .then(() => {
          this.loading = true;
          this.$http.post(this.$host+'/api/BgGroupDelete',{
              IDX:item.IDX
            , ADMIN_IDX:item.ADMIN_IDX
          },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
          .then((result)=>{
            this.loading = false;
            if(result.data.resultCode == 0){

              //토큰 저장
              if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
              }
              if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
              }
              this.$alert(this.$t("common_delete_com")).then(()=>{
                const p = this.page;
                this.page = 0;
                this.loadpage(p);
              });
                
            }else if(result.data.resultCode == 2){
              //로그인 필요
              this.$alert(this.$t("common_tokener"));
              this.$session.clear("ADMIN_IDX");
              this.$session.clear("COM_IDX");
              this.$session.clear("ACNT_IDX");
              this.$session.clear("GRADE");
              this.$session.clear("COM_NAME");
              this.$session.clear("ACCESSTOKEN");
              this.$session.clear("REFLASHTOKEN");
              this.$router.push('Login');   //로그인 페이지로 이동
              
            }else{
              this.$alert(this.$t("common_delete_fail"));
            }
            
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error)=>{
              this.loading = false;
              this.$alert(this.$t("common_delete_error"));
          });      

        });

      },

      //다이얼로그 닫기
      close () {
        this.dialog     = false
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)
      },

      //추가 저장
      save () {
        
        if (this.editedIndex > -1) {

          //수정
          this.loading = true;
          this.$http.post(this.$host+'/api/BgGroupUpdate',{
                IDX:this.editedItem.IDX
              , ADMIN_IDX:this.$session.get("ADMIN_IDX")
              , COM_IDX:this.editedItem.COMIDX
              , NAME: escape(this.editedItem.NAME)
              , DESC: escape(this.editedItem.DESC)
              , BGTYPE: this.editedItem.BGTYPE
          },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
          .then((result)=>{
            this.loading = false;
            if(result.data.resultCode == 0){

              //토큰 저장
              if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
              }
              if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
              }
                this.$alert(this.$t("common_edit_msg")).then(()=>{
                  const p = this.page;
                  this.page = 0;
                  this.loadpage(p);
                });
           

              }else if(result.data.resultCode == 2){
                //로그인 필요
                this.$alert(this.$t("common_tokener"));
                this.$session.clear("ADMIN_IDX");
                this.$session.clear("COM_IDX");
                this.$session.clear("ACNT_IDX");
                this.$session.clear("GRADE");
                this.$session.clear("COM_NAME");
                this.$session.clear("ACCESSTOKEN");
                this.$session.clear("REFLASHTOKEN");
                this.$router.push('Login');   //로그인 페이지로 이동

              }else{
                  this.$alert(this.$t("common_edit_fail"));
              }

          })
          // eslint-disable-next-line no-unused-vars
          .catch((error)=>{
            this.loading = false;
            this.$alert(this.$t("common_edit_fail"));
          });


        }else{

          if(this.editedItem.NAME == undefined || this.editedItem.NAME.length < 1){
            this.$alert(this.$t('deviceadminbg_msg1'));
            return;
          } 
          if(this.editedItem.DESC == undefined || this.editedItem.DESC.length < 1){
            this.$alert(this.$t('deviceadminbg_msg2'));
            return;
          } 

          //신규
          this.loading = true;
          this.$http.post(this.$host+'/api/BgGroupInsert',{
                ADMIN_IDX:this.$session.get("ADMIN_IDX")
              , COM_IDX: this.SEARCH_COM_IDX
              , NAME: escape(this.editedItem.NAME)
              , DESC: escape(this.editedItem.DESC)
              , BGTYPE: this.editedItem.BGTYPE
          },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
          .then((result)=>{
            this.loading = false;
            if(result.data.resultCode == 0){

              //토큰 저장
              if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
              }
              if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
              }
                this.$alert(this.$t('common_insert_msg')).then(()=>{
                  const p = this.page;
                  this.page = 0;
                  this.loadpage(p);
                });

            }else if(result.data.resultCode == 2){
              //로그인 필요
              this.$alert(this.$t("common_tokener"));
              this.$session.clear("ADMIN_IDX");
              this.$session.clear("COM_IDX");
              this.$session.clear("ACNT_IDX");
              this.$session.clear("GRADE");
              this.$session.clear("COM_NAME");
              this.$session.clear("ACCESSTOKEN");
              this.$session.clear("REFLASHTOKEN");
              this.$router.push('Login');   //로그인 페이지로 이동

            }else{
              this.$alert(this.$t("common_insert_fail"));
            }
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error)=>{
            this.loading = false;
            this.$alert(this.$t("common_insert_fail"));
          });


        }

        this.close()
      },      


      //조회
      loadpage2(p){

          this.loading2 = true;
          this.page2 = p;

          this.$http.post(this.$host+'/api/BGList',{
                page: this.page
              , pagerow: this.pagerow
              , BGGROUP_IDX: this.PARENT_ITEM.IDX
              , ADMIN_IDX:this.$session.get("ADMIN_IDX")
              , LAN_CODE:this.$i18n.locale
          },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
          .then((result)=>{
            
            this.loading2 = false;
            if(result.data.resultCode == 0){

                //토큰 저장
                if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                  this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
                }
                if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                  this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
                }

                const list = result.data.resultData;
                this.itemList2.splice(0, this.itemList2.length);   //데이터 초기화
                list.forEach(element => {
                    element.BGTYPE = this.PARENT_ITEM.BGTYPE;
                    this.itemList2.push(element); 
                });
                

            }else if(result.data.resultCode == 2){
              //로그인 필요
              this.$alert(this.$t("common_tokener"));
              this.$session.clear("ADMIN_IDX");
              this.$session.clear("COM_IDX");
              this.$session.clear("ACNT_IDX");
              this.$session.clear("GRADE");
              this.$session.clear("COM_NAME");
              this.$session.clear("ACCESSTOKEN");
              this.$session.clear("REFLASHTOKEN");
              this.$router.push('Login');   //로그인 페이지로 이동

            }else{
              
              this.loading = false;
            }
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error)=>{
            
            this.loading = false;
          });

      },


      //배경그룹에 종속된 배경컨텐츠 리스트 확인
      detail_item(item){

        this.PARENT_ITEM = item;
        this.page2 = 1;
        
        this.$http.post(this.$host+'/api/BGList',{
                page: this.page2
              , pagerow: this.pagerow
              , ADMIN_IDX: this.$session.get("ADMIN_IDX")
              , BGGROUP_IDX: this.PARENT_ITEM.IDX
              , LAN_CODE:this.$i18n.locale
        },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
        .then((result)=>{

            this.loading2 = false;
            if(result.data.resultCode == 0){

              //토큰 저장
              if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
              }
              if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
              }
                const list = result.data.resultData;
                this.itemList2.splice(0, this.itemList2.length);   //데이터 초기화
                list.forEach(element => {
                    element.BGTYPE = this.PARENT_ITEM.BGTYPE;
                    this.itemList2.push(element); 
                });

            }else if(result.data.resultCode == 2){
              //로그인 필요
              this.$alert(this.$t("common_tokener"));
              this.$session.clear("ADMIN_IDX");
              this.$session.clear("COM_IDX");
              this.$session.clear("ACNT_IDX");
              this.$session.clear("GRADE");
              this.$session.clear("COM_NAME");
              this.$session.clear("ACCESSTOKEN");
              this.$session.clear("REFLASHTOKEN");
              this.$router.push('Login');   //로그인 페이지로 이동

            }
        })
        // eslint-disable-next-line no-unused-vars
        .catch((error)=>{
          
          this.loading2 = false;
        });

      },


      edit_img(item){
        this.selectFile   = null;
        this.editedItem2  = item;
        this.editedIndex2 = this.itemList2.indexOf(item);
        this.dialog2 = true;
      },
      
      delete_img(item){

        //삭제할 파일의 path를 서버로 전달한다.
        var filename    = item.FILEPATH.substring(item.FILEPATH.lastIndexOf('com/')+4);

        this.$confirm(this.$t('deviceadminbg_msg3'))
        .then(() => {

          this.loading2 = true;
          this.$http.post(this.$host+'/api/BGDelete',{
                IDX:item.IDX
              , ADMIN_IDX:item.ADMIN_IDX
              , FILEPATH:filename
          },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
          .then((result)=>{
            
            this.loading2 = false;
            if(result.data.resultCode == 0){
              //토큰 저장
              if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
              }
              if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
              }
              this.$alert(this.$t("common_delete_com")).then(()=>{
                const p = this.page2;
                this.page2 = 0;
                this.loadpage2(p);
              });
              
            }else if(result.data.resultCode == 2){
              //로그인 필요
              this.$alert(this.$t("common_tokener"));
              this.$session.clear("ADMIN_IDX");
              this.$session.clear("COM_IDX");
              this.$session.clear("ACNT_IDX");
              this.$session.clear("GRADE");
              this.$session.clear("COM_NAME");
              this.$session.clear("ACCESSTOKEN");
              this.$session.clear("REFLASHTOKEN");
              this.$router.push('Login');   //로그인 페이지로 이동

            }else{
              this.$alert(this.$t("common_delete_fail"));
            }
            
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error)=>{
              this.loading2 = false;
              this.$alert(this.$t("common_delete_error"));
          });      
          
        });

      },

      insert_img(){
        if(this.PARENT_ITEM.IDX == undefined){
          this.$alert(this.$t('deviceadminbg_msg4'));
          return;
        }
        this.editedItem2      = Object.assign({}, this.defaultItem2);
        this.editedItem2.SORT = this.itemList2.length;
        this.editedIndex2 = -1;
        this.dialog2 = true;
      },

      save_img(upath){

        this.upload_path = upath;

        if(this.editedIndex2 > -1){
          
          //수정
          this.loading2 = true;

          this.$http.post(this.$host+'/api/BGUpdate',{
              FILEPATH: this.upload_path != null ? this.upload_path : null
            , TITLE: escape(this.editedItem2.TITLE)
            , STATE: this.editedItem2.STATE
            , TYPE: this.editedItem2.TYPE
            , SORT: this.editedItem2.SORT
            , ADMIN_IDX: this.$session.get("ADMIN_IDX")
            , BGGROUP_IDX: this.PARENT_ITEM.IDX
            , IDX: this.editedItem2.IDX
          },{headers:{accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
          .then((result)=>{
            
            this.loading = false;
            if(result.data.resultCode == 0){
              //토큰 저장
              if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
              }
              if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
              }
                this.$alert(this.$t("common_edit_msg")).then(()=>{
                  const p = this.page2;
                  this.page2 = 0;
                  this.loadpage2(p);
                });

            }else if(result.data.resultCode == 2){
              //로그인 필요
              this.$alert(this.$t("common_tokener"));
              this.$session.clear("ADMIN_IDX");
              this.$session.clear("COM_IDX");
              this.$session.clear("ACNT_IDX");
              this.$session.clear("GRADE");
              this.$session.clear("COM_NAME");
              this.$session.clear("ACCESSTOKEN");
              this.$session.clear("REFLASHTOKEN");
              this.$router.push('Login');   //로그인 페이지로 이동

            }else{
              this.$alert(this.$t('common_process_fail'));
            }
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error)=>{
            this.loading2 = false;
            this.$alert(this.$t('common_process_fail'));
          });          


        }else{

          //수정
          this.loading2 = true;
          this.$http.post(this.$host+'/api/BGInsert', {
              FILEPATH: this.upload_path != null ? this.upload_path : null
            , TITLE: escape(this.editedItem2.TITLE)
            , STATE: this.editedItem2.STATE
            , TYPE: this.editedItem2.TYPE
            , SORT: this.editedItem2.SORT
            , ADMIN_IDX: this.$session.get("ADMIN_IDX")
            , BGGROUP_IDX: this.PARENT_ITEM.IDX
          },{headers:{accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
          .then((result)=>{
            
            this.loading = false;
            if(result.data.resultCode == 0){
              //토큰 저장
              if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
              }
              if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
              }
                this.$alert(this.$t('common_insert_msg')).then(()=>{
                  const p = this.page2;
                  this.page2 = 0;
                  this.loadpage2(p);
                });

            }else if(result.data.resultCode == 2){
              //로그인 필요
              this.$alert(this.$t("common_tokener"));
              this.$session.clear("ADMIN_IDX");
              this.$session.clear("COM_IDX");
              this.$session.clear("ACNT_IDX");
              this.$session.clear("GRADE");
              this.$session.clear("COM_NAME");
              this.$session.clear("ACCESSTOKEN");
              this.$session.clear("REFLASHTOKEN");
              this.$router.push('Login');   //로그인 페이지로 이동

            }else{
              this.$alert(this.$t('common_process_fail'));
            }
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error)=>{
            this.loading2 = false;
            this.$alert(this.$t('common_process_fail'));
          });          

        }

        this.dialog2 = false
        setTimeout(() => {
          this.editedItem2 = Object.assign({}, this.defaultItem2)
          this.editedIndex2 = -1
          this.uploadFile = null;
        }, 300)


      },


      changefile(){

        //파일명 백업
        this.selectFile = this.uploadFile.name;
        if(this.uploadFile.size/1024/1024 > 20){
          this.$alert(this.$t('devicedaminbg_msg5'));
          this.uploadFile = null;
          return;
        }

        /*
        if (file && file.type.match(/^image\/(png|jpeg)$/)) {
          var temp = window.URL.createObjectURL(file) //로컬 파일 경로를 가지고 이미지를 보여준다.
          this.editedItem2.FILEPATH = temp;
        }
        */


        //이미지 크롭 팝업 띄우기
        const reader = new FileReader();
        reader.onload = (event)=>{
          
          //선택된 파일명 백업
          if(this.PARENT_ITEM.BGTYPE == 0){ //가로
            this.crop_dialog_land = true;
            this.imgSrc = event.target.result;  //이게 blob데이터
            this.$refs.cropper_land.replace(event.target.result);
          }else if(this.PARENT_ITEM.BGTYPE == 1){
            this.crop_dialog_port = true;
            this.imgSrc = event.target.result;
            this.$refs.cropper_port.replace(event.target.result);
          }else{
            this.crop_dialog_print = true;
            this.imgSrc = event.target.result;
            this.$refs.cropper_port.replace(event.target.result);
          }
        }
        reader.readAsDataURL(this.uploadFile);  //비동기로 파일을 읽어서

        

      },

      changefile2(){
        
        this.selectFile = this.uploadFile.name;
        
        var file = this.uploadFile;
        if(file.size/1024/1024 > 100){
          this.$alert(this.$t('devicedaminbg_msg9'));
          this.uploadFile = null;
          return;
        }

        //if (file && file.type.match(/^video\/(mp4)$/)) {

          //동영상 미리보기 처리
          var temp = window.URL.createObjectURL(file);
          this.editedItem2.FILEPATH = temp;

          //s3업로드시 blob으로 올리기 때문에 변환해준다.
          const reader = new FileReader();
          reader.onload = (event)=>{
            this.uploadFile = event.target.result;  //이게 blob데이터
          }
          reader.readAsDataURL(this.selectFile);  //비동기로 파일을 읽어서

        //}

      },


      //업체선택 콜백
      comdialogcb(val){
        if(val.NAME.length > 0){
          this.editedItem.COM_NAME = val.NAME;
          this.editedItem.COM_IDX  = val.IDX;
        }else{
          this.$alert(this.$t('common_select_company'));
          return;
        }
      },


      //검색조건 업체 설정
      comsearchcb(val1){
        if(val1.NAME.length > 0){
          this.SEARCH_COM_NAME = val1.NAME;
          this.SEARCH_COM_IDX  = val1.IDX;
        }else{
          this.SEARCH_COM_NAME = '';
          this.SEARCH_COM_IDX  = null;
        }
        this.$session.set("COM_IDX",  this.SEARCH_COM_IDX);
        this.$session.set("COM_NAME", this.SEARCH_COM_NAME);
        this.$session.set("EVENT_IDX", null);
        this.$session.set("EVENT_NAME", "");

        this.loadpage(1);

      },      

      // eslint-disable-next-line no-unused-vars
      comsearchclear(var2){
          this.SEARCH_COM_IDX  = null;
          this.SEARCH_COM_NAME = '';
          this.$session.set("COM_IDX",  null);
          this.$session.set("COM_NAME", "");
          this.$session.set("EVENT_IDX", null);
          this.$session.set("EVENT_NAME", "");
          this.loadpage(1);
      },

      cancel_crop(){
        this.crop_dialog_land = false;
        this.crop_dialog_port = false;
        this.crop_dialog_print = false;
      },

      cropimg(){

        //이미지 크롭
        if(this.PARENT_ITEM.BGTYPE == 0){
          //가로
          this.$refs.cropper_land.getCroppedCanvas().toBlob(blob =>{
            this.crop_dialog_land = false;
            this.uploadFile = blob;
            //var crop_data = JSON.stringify(this.$refs.cropper.getCropBoxData(), null, 4);
            this.editedItem2.FILEPATH = this.$refs.cropper_land.getCroppedCanvas().toDataURL(); //이미지뷰 미리보기용
            //console.log("filepath : " + this.editedItem2.FILEPATH);
          })

        }else if(this.PARENT_ITEM.BGTYPE == 1){
          //세로
          this.$refs.cropper_port.getCroppedCanvas().toBlob(blob =>{
            this.crop_dialog_port = false;
            this.uploadFile = blob;
            //var crop_data = JSON.stringify(this.$refs.cropper.getCropBoxData(), null, 4);
            this.editedItem2.FILEPATH = this.$refs.cropper_port.getCroppedCanvas().toDataURL();
            //console.log("filepath : " + this.editedItem2.FILEPATH);
          })

        }else{
          this.$refs.cropper_print.getCroppedCanvas().toBlob(blob =>{
            this.crop_dialog_print = false;
            this.uploadFile = blob;
            //var crop_data = JSON.stringify(this.$refs.cropper.getCropBoxData(), null, 4);
            this.editedItem2.FILEPATH = this.$refs.cropper_print.getCroppedCanvas().toDataURL();
            //console.log("filepath : " + this.editedItem2.FILEPATH);
          })

        }
      },
      
      //s3 폴더를 확인 및 업로드
      async checks3path(){
        
        const s3obj      = this.$s3;
        const save_img_f = this.save_img;

        const temp_blob = this.uploadFile;      //크롭된 이미지의 blob데이터
        const temp_url  = this.selectFile;      //크롭전 선택된 이미지 파일명
        const folder    = this.SEARCH_COM_IDX.toString();         //중간폴더명
        var albumPhotosKey = encodeURIComponent(folder) + "/";    //중간경로명  /게 붙어야 폴더됨.

        if(temp_url == null){
          save_img_f();
          return;
        }


        if(this.uploadFile.size/1024/1024 > 50){
          this.$alert(this.$t('deviceadminbg_msg6'));
          return;
        }



        var extens    = temp_url.split(".");
        let extension = extens[extens.length-1];
        var filename = Date.now().toString()+"."+extension;       //파일명
        var photoKey = albumPhotosKey + filename;                 //최종 경로

        if (this.editedIndex2 > -1) {

          //수정
          if(this.selectFile == undefined || this.selectFile.length < 1){
            
            //변경된 리소스가 없으면 바로 업데이트
            save_img_f();
            return;
          }

        }else{

          //추가
          if(this.selectFile == undefined || this.selectFile.length < 1){
            
            if(this.uploadFile == undefined || this.uploadFile.length < 1){
              this.$alert(this.$t('deviceadminbg_msg7'));
              return;
            } 
          }
        }

        //파일 업로드 - 중간 경로까지 자동 생성됨.
        // eslint-disable-next-line no-unused-vars
        s3obj.putObject({Key: albumPhotosKey}, async (err2, data2) => {
          if (err2) {
            //앨범생성 오류
            this.$alert(this.$t('deviceadminbg_msg8'));
            return;
          }else{
            //앨범생성 성공 - 업로드
            s3obj.upload({
                Bucket: "blueorigin-mice-image",
                Key: photoKey,
                Body: temp_blob,
                ACL: "public-read"
            // eslint-disable-next-line no-unused-vars
            }, function(err,data){
                if(err){
                  //업로드 실패
                  this.$alert(this.$t('deviceadminbg_msg8'));
                }else{
                  //업로드 성공
                  if(data.Location != null && data.Location.length > 0){
                    console.log("upload complete :" + data.Location);
                    save_img_f(data.Location);
                  }else{
                    this.$alert(this.$t('deviceadminbg_msg8'));
                  }
                }
              })
            }
          });   

      }

    },
  
}
</script>

<!-- scoped가 있으면 해당 컴포넌트에서만 스타일이 반영됨 -->
<style scoped>


</style>